<template>
	<div class="pages-body accessdenied-page flex flex-column">
		<div class=" p-3 flex justify-content-between flex-row align-items-center">
			<router-link class="topbar-left ml-3 flex" to="/login">
				<div class="logo">
				</div>
			</router-link>
		</div>

		<div class="align-self-center mt-auto mb-auto">
			<div class="pages-panel card flex flex-column">
				<div class="pages-header px-3 py-1">
					<h2>ACCESO DENEGADO</h2>
				</div>
				<div class="card mt-3 px-6">
					<img src="layout/images/pages/error.png" alt=""  @click="volverlogin"/>
				</div>
				<Timer :verification_code_sent_at="verification_code_sent_at" /> 
				<div class="pages-detail pb-4">Hemos enviado un correo a su email, por favor confirmelo <br> para pasar a aprobación por la empresa de transporte.</div>
				<div class="flex grid p-fluid">
					<div class="col-12 lg:col-12 mb-1">
						<span class="p-float-label">
							<InputMask mask="9-9-9-9-9-9" id="title" v-model="codigo_verificacion" />
							<label for="title">Codigo Verificación</label>
						</span>
						<Button type="button" :loading="loader" :disabled="isDateInFuture() == true" label="VERIFICAR CODIGO" class="p-button-primary" @click="verify"></Button>
					</div>
					<div class="col-12 lg:col-12 mb-3">
						<p>Disponible hasta: <br>{{verification_code_sent_at}}</p>
					</div>
				</div>
				
					<Button :loading="loader" type="button" label="REENVIAR EMAIL" class="p-button-primary" @click="resend"></Button>

				<router-link to="/login">
					<Button :loading="loader" type="button" label="VOLVER AL LOGIN" class="p-button-text" @click="volverlogin"></Button>
				</router-link>
				<Toast />
			</div>
		</div>
	</div>

</template>

<script>
import Timer from './Timer.vue'
import EventBus from '../event-bus';
import axios from 'axios'
	export default {
		data() {
			return {
				loader: false,
				codigo_verificacion: '',
				verification_code_sent_at: '',
			}
		},
		mounted(){
			const FechaVerified = 'FechaVerified';
			let cookie = {};
			document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookie[key.trim()] = value;
			})
			var email = cookie[FechaVerified];
			this.verification_code_sent_at = email;
			EventBus.emit('show-timer');
		},
		methods: {
			resend(){
				this.loader = true;
				this.verification_code_sent_at = '';
				var _that = this;
				var correo =  document.cookie.split(";");
				var email = correo[1].replace(' Email=', '');
				console.log(email);
				axios.post('/email/resend', {email: email}).then((response) => {
                            console.log(response.data.message);
							document.cookie = "FechaVerified="+response.data.verification_code_sent_at;
							_that.verification_code_sent_at = response.data.verification_code_sent_at;
							// EventBus.emit('show-timer');
                            _that.$toast.add({severity:'success', summary: 'Reenvio exitoso', detail:response.data.message, life: 5000});
                            _that.loader = false;
                            // _that.registro = false;
                            // _that.closeModal();
                            
                        }).catch(function (error) {
                        if (error.response) {
                        // Request made and server responded
                        console.log(error.response.data);
                        console.log(error.response.status);
                        console.log(error.response.headers);
                        _that.loader = false;
                        } else if (error.request) {
                            _that.loader = false;
                        // The request was made but no response was received
                        // console.log(error.request);
                        } else {
                            _that.loader = false;
                        // Something happened in setting up the request that triggered an Error
                        // console.log('Error', error.message);
                        }
                    });
			},
			isDateInFuture() {
				const currentTime = new Date().getTime(); // Obtiene la fecha y hora actual en milisegundos
				const verificationTime = new Date(this.verification_code_sent_at).getTime(); // Convierte la fecha de verificación en milisegundos

				return currentTime > verificationTime; // Compara las dos fechas
			},
			verify(){
				if(this.codigo_verificacion==''){
					this.loader = false;
					this.submitted = true;
					this.$toast.add({severity:'error', summary: 'Codigo incompleto', detail:'Debes ingresar el codigo que llego a tu correo', life: 4000});
					return
				}
				var _that = this;
				this.codigo_verificacion = this.codigo_verificacion.replaceAll('-', '');
				this.loader = true;
				window.api.call('post', '/verify-code', {code: this.codigo_verificacion}).then( function(response) {
					if(response.status == 200){
						_that.$toast.add({ severity: 'success', summary: 'VERIFICADO!', detail: 'Se Verifico su email con exito!', life: 6000 });
						_that.loader = false;
						setTimeout(() => {
							_that.volverlogin();
						}, 1000);
					}
				}).catch(function (err) {
					console.log(err);
					_that.loader = false;
					_that.$toast.add({severity:'error', summary: 'Ocurrio un error al verificar', detail:'Favor informar a un admin', life: 6000});
				});
			},
			volverlogin(){
				var _that = this;
				document.cookie="ImgUser=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"; 
				document.cookie="Email=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"; 
				document.cookie="Nombre=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				document.cookie="NameCustomer=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				document.cookie="IdCustomer=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				document.cookie="UrlImgCustomer=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				document.cookie="IdUsuarioRol=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				document.cookie="UserAdminCustomer=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				document.cookie="Rol=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				document.cookie="IdRol=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				document.cookie="FechaVerified=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
				_that.$store.dispatch('infoNavigation/destroyAccess',null);
				_that.$store.dispatch('infoNavigation/destroyIdRol',null);
				_that.$router.push({ path: '/login' });
			}
		},
		components: {
        'Timer': Timer,
    },
	}
</script>

<style scoped>

</style>
